const generalizePath = (path) => {
  return path.replace(/^\/|\/$/, "").replace(/\/+/g, "/");
};

export default generalizePath;